/**
 * JHANGO ROCKS — Parallax Scroll-Over System v15
 * Simple: sticky sections with z-index stacking.
 * Header clearance: sections with [data-header-clearance] get
 * padding-top = header height so title never overlaps the logo.
 */
(function () {
  'use strict';

  var resizeT;
  var headerObserver = null;

  function measureHeader() {
    var hdr = document.querySelector('.hdr-jhango-rocks');
    if (!hdr) return 72;
    var h = hdr.getBoundingClientRect().height || hdr.offsetHeight;
    if (!h || h < 40) h = 72;
    return Math.round(h);
  }

  function setup() {
    var hw = document.querySelector('.header-section-jhango-rocks');
    if (hw) { hw.style.position = 'relative'; hw.style.zIndex = '9999'; }

    var hdrH = measureHeader();
    document.documentElement.style.setProperty('--jhango-hdr-h', hdrH + 'px');

    var sections = document.querySelectorAll('.parallax-stack-jhango-rocks');
    for (var i = 0; i < sections.length; i++) {
      var s = sections[i];
      s.style.zIndex = String(10 + i);

      if (s.querySelector('[data-no-sticky]')) {
        s.style.position = 'relative';
        s.style.top = 'auto';
      } else {
        s.style.position = 'sticky';
        s.style.top = '0';
        /* Promote each sticky section to its own compositor layer.
           iOS Safari handles this much smoother during momentum scroll —
           without it, sticky transitions can visibly jitter on fast scroll. */
        s.style.willChange = 'transform';
        s.style.transform = 'translateZ(0)';
        s.style.backfaceVisibility = 'hidden';
      }

      /* Header clearance: set padding-top on inner element = header height + gap.
         This ensures section title is ALWAYS below the fixed header. */
      var clearEl = s.querySelector('[data-header-clearance]');
      if (clearEl) {
        var padVal = hdrH + 20;
        clearEl.style.setProperty('padding-top', padVal + 'px', 'important');
      }

      /* Ensure section has a background color */
      var bg = window.getComputedStyle(s).backgroundColor;
      if (!bg || bg === 'rgba(0, 0, 0, 0)' || bg === 'transparent') {
        var child = s.firstElementChild;
        var cbg = child ? window.getComputedStyle(child).backgroundColor : '';
        if (!cbg || cbg === 'rgba(0, 0, 0, 0)' || cbg === 'transparent') {
          s.style.backgroundColor = '#ffffff';
        }
      }
    }

    attachHeaderObserver();
  }

  function attachHeaderObserver() {
    if (headerObserver || typeof ResizeObserver === 'undefined') return;
    var hdr = document.querySelector('.hdr-jhango-rocks');
    if (!hdr) return;
    headerObserver = new ResizeObserver(function () {
      clearTimeout(resizeT);
      resizeT = setTimeout(setup, 120);
    });
    headerObserver.observe(hdr);
  }

  function scheduleSetup() {
    clearTimeout(resizeT);
    resizeT = setTimeout(setup, 80);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else { setup(); }

  /* Re-run after full load so images/fonts that change header height are accounted for */
  window.addEventListener('load', scheduleSetup);

  window.addEventListener('resize', function () {
    clearTimeout(resizeT);
    resizeT = setTimeout(setup, 150);
  });
  document.addEventListener('shopify:section:load', setup);
  document.addEventListener('shopify:section:reorder', setup);
})();
